import { useQuery } from "react-query";
import QUERY_KEYS from "../queryKeys";
import commonConfig from "../config";
import { getEventDetails, getEventJoinedTeams } from "./queryFunctions";

export const useEventDetails = (event_id, config = {}) =>
  useQuery({
    queryKey: [QUERY_KEYS.EVENT_DETAILS, event_id],
    queryFn: () => getEventDetails({ event_id }),
    ...commonConfig,
    ...config,
  });

export const useEventJoinedTeams = (event_id, page, limit, config = {}) =>
  useQuery({
    queryKey: [QUERY_KEYS.EVENT_JOINED_TEAMS, event_id, page, limit],
    queryFn: () => getEventJoinedTeams({ event_id, page, limit }),
    ...commonConfig,
    ...config,
  });
